module.exports = __webpack_public_path__ + "img/1.a35e983e.png";